import { MessageDescriptor } from 'react-intl';
import { App } from '@gin-betting/core';
import globalMsg from 'messages';

export const msgMapping: { [K in App.OddFormat]: MessageDescriptor } = {
    [App.OddFormat.Decimal]: globalMsg.Decimal,
    [App.OddFormat.Fractional]: globalMsg.Fractional,
    [App.OddFormat.HongKong]: globalMsg.HongKong,
    [App.OddFormat.Indo]: globalMsg.Indo,
    [App.OddFormat.Malay]: globalMsg.Malay,
    [App.OddFormat.US]: globalMsg.US,
};
